module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "xl",
      "title": _vm.title,
      "hide-footer": "",
      "header-bg-variant": "primary",
      "header-text-variant": "white"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('update:visible', false)
      }
    },
    model: {
      value: (_vm.localVisible),
      callback: function($$v) {
        _vm.localVisible = $$v
      },
      expression: "localVisible"
    }
  }, [
    [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center w-100 pr-4"
    }, [_c('h5', {
      staticClass: "modal-title text-white mb-0"
    }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showExport) ? _c('b-button', {
      staticClass: "shadow-sm font-weight-bold",
      attrs: {
        "variant": "light",
        "size": "sm",
        "disabled": _vm.isExporting || _vm.loading || !_vm.items.length
      },
      on: {
        "click": function($event) {
          _vm.$emit('export')
        }
      }
    }, [(_vm.isExporting) ? [_c('b-spinner', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      }
    }), _vm._v("\n          Exporting…\n        ")] : [_c('i', {
      staticClass: "fa fa-download mr-1"
    }), _vm._v("\n          Excel Export\n        ")]], 2) : _vm._e()], 1)], _vm._v(" "), (_vm.loading) ? _c('div', {
      staticClass: "text-center py-5"
    }, [_c('b-spinner', {
      attrs: {
        "variant": "primary"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-muted small mt-2 mb-0"
    }, [_vm._v("Loading…")])], 1) : (_vm.errorMessage) ? _c('div', {
      staticClass: "alert alert-danger mb-0"
    }, [_vm._v(_vm._s(_vm.errorMessage))]) : _c('b-table', {
      staticClass: "mb-0 custom-table",
      attrs: {
        "items": _vm.items,
        "fields": _vm.fields,
        "hover": "",
        "striped": "",
        "small": "",
        "responsive": "",
        "show-empty": "",
        "empty-text": "No records for this range."
      },
      scopedSlots: _vm._u([{
        key: "index",
        fn: function(data) {
          return [_vm._v("\n      " + _vm._s((_vm.page - 1) * _vm.pageSize + data.index + 1) + "\n    ")]
        }
      }, {
        key: "status",
        fn: function(data) {
          return [_c('b-badge', {
            attrs: {
              "variant": _vm.getStatusVariant(data.item.status),
              "pill": ""
            }
          }, [_vm._v("\n        " + _vm._s(data.item.status || "N/A") + "\n      ")])]
        }
      }])
    }), _vm._v(" "), (!_vm.loading && !_vm.errorMessage && _vm.total > 0) ? _c('div', {
      staticClass: "d-flex justify-content-between align-items-center mt-3 pt-3 border-top"
    }, [_c('b-pagination', {
      staticClass: "mb-0",
      attrs: {
        "total-rows": _vm.total,
        "per-page": _vm.pageSize,
        "size": "sm"
      },
      on: {
        "change": function($event) {
          _vm.$emit('page-change', $event)
        }
      },
      model: {
        value: (_vm.localPage),
        callback: function($$v) {
          _vm.localPage = $$v
        },
        expression: "localPage"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "small text-muted font-italic"
    }, [_vm._v("\n      Showing " + _vm._s(_vm.items.length) + " of " + _vm._s(_vm.total) + " records\n    ")])], 1) : _vm._e()
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f9025b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/VehicleUtilizationDrilldownModal.vue
// module id = 2702
// module chunks = 0